/* Écran de fin de parcours : le passager ne peut pas jouer, et on lui dit
   pourquoi. Quatre cas y passent (page ouverte hors mobile, lien sans matricule,
   véhicule inconnu, QR désactivé) — un seul dessin, pour que le message change
   sans que la carte change. */
import BrandLogo from "@/components/BrandLogo";

export default function ScanBlocked({ icon: Icon, title, message, testId }) {
  return (
    <div className="min-h-[100dvh] w-full grid place-items-center bg-background px-6">
      <div
        className="w-full max-w-sm rounded-3xl border-2 border-border bg-card p-8 text-center"
        style={{ boxShadow: "var(--shadow-card)" }}
        data-testid={testId}
      >
        <div
          className="mx-auto mb-5 h-16 w-16 rounded-2xl grid place-items-center"
          style={{ background: "var(--color-brand-fill)", color: "#fff" }}
        >
          <Icon className="h-8 w-8" />
        </div>
        <h1 className="font-heading text-2xl font-bold leading-tight">{title}</h1>
        <p className="text-sm text-muted-foreground mt-3">{message}</p>
        <div className="mt-6 flex items-center justify-center">
          <BrandLogo className="h-5 opacity-60" />
        </div>
      </div>
    </div>
  );
}
